import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {MatDialogRef} from '@angular/material';

import {IGroupedDevice} from '../../../shared';
import {Device} from '../../../afb-api/models/device';
import {OrganizationUser} from '../../../afb-api/models/organization-user';

@Component({
  selector: 'awair-member-mgmt-dialog',
  templateUrl: './member-mgmt-dialog.component.html',
  styleUrls: ['./member-mgmt-dialog.component.scss']
})

export class MemberMgmtDialogComponent implements OnInit {

  @Output() save: EventEmitter<{
    removeMemberList: OrganizationUser[],
    inviteMemberList: string[],
    addMemberList: OrganizationUser[],
    groupId: string
  }> = new EventEmitter();

  // Inputs
  selectedGroup: IGroupedDevice;
  orgUserList: OrganizationUser[];
  orgOwner: OrganizationUser;
  orgAdminList: OrganizationUser[];
  activeOrgMemberList: OrganizationUser[];
  pendingOrgMemberList: OrganizationUser[];

  selectedGroupMemberList: IMgmtOrgUser[] = [];
  otherGroupMemberList: IMgmtOrgUser[] = [];

  addCtr: number = 0;
  removeCtr: number = 0;
  inviteeList: string[] = [];

  selectedTabIndex: number;

  isLoading: boolean = false;

  constructor(private myDialogRef: MatDialogRef<MemberMgmtDialogComponent>) {
  }

  ngOnInit() {
    const splitedObj = this.splitOrgMemberList(this.activeOrgMemberList);
    this.selectedGroupMemberList = <IMgmtOrgUser[]>this.sortByEmail(splitedObj.selectedGroup);
    this.otherGroupMemberList = <IMgmtOrgUser[]>this.sortByEmail(splitedObj.otherGroup);
    this.pendingOrgMemberList = <OrganizationUser[]>this.sortByEmail(this.pendingOrgMemberList);
  }

  tabSelected(selectedTabIndex: number) {
    this.selectedTabIndex = selectedTabIndex;
  }

  addInvitee(email: string): void {
    // Not mutating original object to reflect input
    this.inviteeList = [...this.inviteeList, email];
    this.addCtr = this.otherGroupMemberList
      .filter((otherGroupMember: IMgmtOrgUser) => otherGroupMember.isChecked === true).length + this.inviteeList.length;
    this.selectedTabIndex = 2;
  }

  removeInvitee(email: string): void {
    this.inviteeList = [...this.inviteeList.filter((invitee: string) => invitee !== email)];
    this.addCtr = this.otherGroupMemberList
      .filter((otherGroupMember: IMgmtOrgUser) => otherGroupMember.isChecked === true).length + this.inviteeList.length;
  }

  toggleSelectedGroupMember(isAdded: boolean, index: number): void {
    this.selectedGroupMemberList[index].isChecked = isAdded;
    this.removeCtr = this.selectedGroupMemberList
      .filter((selectedGroupMember: IMgmtOrgUser) => selectedGroupMember.isChecked === false).length;
  }

  toggleOtherGroupMember(isAdded: boolean, index: number): void {
    this.otherGroupMemberList[index].isChecked = isAdded;
    this.addCtr = this.otherGroupMemberList
      .filter((otherGroupMember: IMgmtOrgUser) => otherGroupMember.isChecked === true).length + this.inviteeList.length;
  }

  onSave(): void {
    const removeMemberList: OrganizationUser[] =
      this.selectedGroupMemberList.filter((selectedGroupMember: IMgmtOrgUser) => selectedGroupMember.isChecked === false);
    const inviteMemberList: string[] = [...this.inviteeList];
    const addMemberList: OrganizationUser[] =
      this.otherGroupMemberList.filter((otherGroupMember: IMgmtOrgUser) => otherGroupMember.isChecked === true);

    this.save.emit({
      removeMemberList,
      inviteMemberList,
      addMemberList,
      groupId: this.selectedGroup.id
    });
  }

  onClose(): void {
    if (this.addCtr === 0 && this.removeCtr === 0) {
      this.myDialogRef.close();
    } else {
      if (confirm('Changes will not be saved.\nAre you sure you want to exit?')) {
        this.myDialogRef.close();
      }
    }
  }

  private splitOrgMemberList(orgMemberList: OrganizationUser[]): { selectedGroup: IMgmtOrgUser[], otherGroup: IMgmtOrgUser[] } {
    const selectedGroupMemberList: IMgmtOrgUser[] = [];
    const otherGroupMemberList: IMgmtOrgUser[] = [];

    orgMemberList.forEach((orgMember: OrganizationUser) => {
      if (orgMember.groups.indexOf(Number(this.selectedGroup.id)) !== -1) {
        selectedGroupMemberList.push({
          ...orgMember,
          isChecked: true,
          deviceListLength: this.selectedGroup.deviceList.filter((device: Device) => device.email === orgMember.email).length
        });
      } else {
        otherGroupMemberList.push({...orgMember, isChecked: false});
      }
    });

    return {
      'selectedGroup': selectedGroupMemberList,
      'otherGroup': otherGroupMemberList
    };
  }

  private sortByEmail(orgUserList: OrganizationUser[] | IMgmtOrgUser[]): OrganizationUser[] | IMgmtOrgUser[] {
    const copyOrgUserList = [...orgUserList];
    // Needs to show device list in alphabetical order
    // Not using objArraySort pipe since it breaks multi select logic
    return copyOrgUserList.sort((a: OrganizationUser, b: OrganizationUser) => {
      if (a.email < b.email) {
        return -1;
      } else if (a.email > b.email) {
        return 1;
      } else {
        return 0;
      }
    });
  }
}

export interface IMgmtOrgUser extends OrganizationUser {
  isChecked: boolean;
  deviceListLength?: number;
}
